<template>
  <nuxt/>
</template>

<script>
import {ding_erformance} from "./js/entConsoleDate.js"
  export default {
    name: "empty",
    mounted() {
      ding_erformance()
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// layouts/empty.vue